import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MerchantService } from '../_services/merchant.service';

@Injectable({
  providedIn: 'root'
})
export class ProdGuard  {
  private readonly merchantService: MerchantService = inject(MerchantService);
  private readonly router: Router = inject(Router);

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      this.merchantService.checkSession();
      if (this.merchantService.currentMerchant && this.merchantService.accessAllowed) {
        return true;
      } else {
        return this.merchantService.isLoggedIn().pipe(map(
          (isLoggedIn) => {
            if (isLoggedIn && this.merchantService.currentMerchant && this.merchantService.currentMerchant.role === 'USER') {
              return true;
            } else {
              this.router.navigate(['public/home'], {});
              return false;
            }
          }
        ));
      }
    }
  }
